export interface ConfigAudit {
  enabled: boolean;
  max_body?: string;
  strict_ssl?: boolean;
  timeout?: number;
}
